import { useTranslation } from "react-i18next";

import { AboutPage } from "../../components/AboutPage/AboutPage";

export function AboutProgram() {
  const { t } = useTranslation();
  return (
    <AboutPage
      title={t("common.applicationTitle")}
      version={t("common.appVersion")}
      logo={"\\eUpisiLogo.png"}
    />
  );
}
